<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="指挥部名称">
              <a-input v-model="queryParam.name" placeholder="请输入防疫指挥部名称" ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory']">
              <a-select
                :placeholder="language['common.pleaseInput']+language['factory']"
                v-model="queryParam.factoryId" :options="factoryOptions"
                allowClear>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.principalName" placeholder="请输入负责人姓名" ></a-input>
              </a-form-item>
            </a-col>


            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="负责人工号">
                <a-input v-model="queryParam.employeeNo" placeholder="请输入负责人工号"></a-input>
              </a-form-item>
            </a-col>


              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="手机">
                    <a-input v-model="queryParam.principalMobile" placeholder="请输入手机" ></a-input>
                  </a-form-item>
              </a-col>
          </template>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
               <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'command:add'">新增</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('pre_command')">导出</a-button>-->
      <a-dropdown v-if="selectedRowKeys.length > 0"  v-has="'command:batchDelete'">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="customSwitch" slot-scope="text,record">
          <!--<a-switch :checked-children="language['open']" :un-checked-children="language['close']" v-model="record.status != 0"  @change="onSwitchChange(record,$event)" />-->
          <j-switch v-model="record.status" @change="onSwitchChange(record,$event)"  ></j-switch>
        </template>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)"  v-has="'command:edit'">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item  v-has="'command:detail'">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item  v-has="'command:delete'">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <pre-command-modal ref="modalForm" @ok="modalFormOk" :factoryOptions="factoryOptions"></pre-command-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PreCommandModal from './modules/PreCommandModal'
  import { getAction } from '@/api/manage'

  export default {
    name: 'PreCommandList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      PreCommandModal
    },
    data () {
      return {
        description: 'pre_command管理页面',

        url: {
          list: "/prevent/command/list",
          delete: "/prevent/command/delete",
          deleteBatch: "/prevent/command/deleteBatch",
          switchChange:'/prevent/command/switchChange',
          exportXlsUrl: "/prevent/command/export-xls",
          factoryList:'/prevent/factory/prefactorys',
        },
        dictOptions:{},
        superFieldList:[],

        factory:[],
        factoryOptions:[],
      }
    },
    created() {
      this.initfactoryList();
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },

      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:'防疫指挥部',
              align:"center",
              dataIndex: 'name'
            },
            {
              title:'厂区',
              align:"center",
              dataIndex: 'factoryNames'
            },
            {
              title:'负责人姓名',
              align:"center",
              dataIndex: 'principalName'
            },
            {
              title:'负责人工号',
              align:"center",
              dataIndex: 'employeeNo'
            },
            {
              title:'系统账号',
              align:"center",
              dataIndex: 'principalAccount'
            },

            {
              title:'邮箱',
              align:"center",
              dataIndex: 'principalEmail'
            },
            {
              title:'座机',
              align:"center",
              dataIndex: 'principalLandline'
            },
            {
              title:'手机',
              align:"center",
              dataIndex: 'principalMobile'
            },
            {
              title:'是否启用',
              align:"center",
              dataIndex: 'status',
              scopedSlots: { customRender: 'customSwitch' }
            },
            {
              title:'创建时间',
              align:"center",
              dataIndex: 'createTime'
            },
            {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }
    },
    methods: {

      initfactoryList(){
        getAction(this.url.factoryList,{pageNo:1,pageSize:99999}).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.name, value: item.id+""}
              return c;
            })
          }
        })
      },

      handleFactoryChange (value)  {
        this.queryParam.factoryId=`${value}`;
      },

      onSwitchChange(val,checked) {
        getAction(this.url.switchChange, {id:val.id,status:checked}).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        })
      },


      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'name',text:'防疫指挥部名称'})
        fieldList.push({type:'string',value:'factoryId',text:'指挥部所属厂区'})
        fieldList.push({type:'string',value:'principalId',text:'负责人ID（关联平台用户）'})
        fieldList.push({type:'string',value:'employeeNo',text:'负责人工号'})
        fieldList.push({type:'string',value:'principalAccount',text:'负责人账号'})
        fieldList.push({type:'string',value:'principalName',text:'负责人姓名'})
        fieldList.push({type:'string',value:'principalEmail',text:'负责人邮箱'})
        fieldList.push({type:'string',value:'principalLandline',text:'负责人座机'})
        fieldList.push({type:'string',value:'principalMobile',text:'负责人手机'})
        fieldList.push({type:'int',value:'status',text:'是否启用'})
        fieldList.push({type:'string',value:'delFlag',text:'是否删除'})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
